module.exports = __webpack_public_path__ + "img/kolaudacia.f280b3a0.svg";